console.log = function () {};
console.error = function () {};
console.warning = function () {};
console.debug = function () {};
console.info = function () {};
console.warn = function () {};

// A $( document ).ready() block.
$(document).ready(function () {
    function gtag_report_conversion(url) {
        console.log("gtag");
        var callback = function () {
            if (typeof url != "undefined") {
                window.location = url;
            }
        };

        gtag("event", "conversion", {
            send_to: "AW-866201184/9k6pCJb7_r8BEODchJ0D",
            event_callback: callback,
        });
        return false;
    }

    function firePixel() {
        !(function (q, e, v, n, t, s) {
            if (q.qp) return;
            n = q.qp = function () {
                n.qp ? n.qp.apply(n, arguments) : n.queue.push(arguments);
            };
            n.queue = [];
            t = document.createElement(e);
            t.async = !0;
            t.src = v;
            s = document.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(window, "script", "https://a.quora.com/qevents.js");
        qp("init", "a1c00dd6fa2541bc84d44577e9f7c02f");
        qp("track", "ViewContent");
        var quora_pixel = new Image(1, 1);
        quora_pixel.src =
            "https://q.quora.com/_/ad/a1c00dd6fa2541bc84d44577e9f7c02f/pixel?tag=ViewContent&noscript=1";
        gtag_report_conversion(window.location);
    }

    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
    });

    // Medium-box-slider section
    $(".flickity-card-slider").flickity({
        cellAlign: "right",
        contain: true,
        groupCells: true,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: 4000,
        imagesLoaded: true,
        wrapAround: true,
    });

    // flickty-testimonials section
    $(".flickty-testimonials").flickity({
        cellAlign: "center",
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        autoPlay: 4000,
        wrapAround: true,
    });

    // active Nav Pills Use Multiple Slider
    $(".nav-pills").on("shown.bs.tab", "a", function (event) {
        // get tab pane
        var selector = event.target.getAttribute("href");
        // trigger resize on tab pane
        $(".flickty-testimonials").flickity("resize");
    });

    // Medium-box-slider section
    $(".flickity-card-slider-left").flickity({
        cellAlign: "center",
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        autoPlay: 4000,
        // wrapAround: true,
        groupCells: true,
    });

    // Team-flickity section
    $(".team-flickity").flickity({
        cellAlign: "left",
        prevNextButtons: false,
        pageDots: false,
        autoPlay: 4000,
        groupCells: 4,
        wrapAround: true,
    });

    // Services Slider section
    $(".flickity-services-slider").flickity({
        cellAlign: "center",
        contain: true,
        prevNextButtons: true,
        pageDots: false,
        autoPlay: 4000,
        wrapAround: true,
    });

    // Mobile Navigation Section
    if (window.matchMedia("(max-width: 768px)").matches) {
        // toggle animation nav
        $(".navbar-mobile-ui").click(function () {
            $(".navbar-mobile-ui").toggleClass("collapsed");
        });

        // Mobile Menu
        $(".navbar-toggle").click(function () {
            $(".mobile-menu-section .navbar-collapse").toggleClass(
                "right-show"
            );
            $(this).toggleClass("fix-toggle-btn");
        });

        $(".navbar").addClass("mobile-menu-section");
    }

    // live chat section

    //====================active nav==========================
    var url = window.location;
    // Will only work if string in href matches with location
    $('ul.navbar-nav a[href="' + url + '"]')
        .parent()
        .addClass("active");

    // Will also work for relative and absolute hrefs
    $("ul.navbar-nav a")
        .filter(function () {
            return this.href == url;
        })
        .parent()
        .addClass("active");

    // activate left navigation based on current link
    var current_url = window.location;
    $(".dropdown-menu li a")
        .filter(function () {
            return this.href == current_url;
        })
        .last()
        .parents("li")
        .addClass("active");

    function submitWebForm(
        form,
        button,
        recaptcha_token,
        thanks_message,
        form_modal = null
    ) {
        var url = form.attr("action");

        var form_data = form.serialize();
        form_data = form_data + "&page_link=" + window.location.href;

        $.ajax({
            type: "POST",
            url: url,
            data: form_data, // serializes the form's elements.
            success: function (data) {
                form[0].reset();
                form.removeClass("was-validated");

                if (form_modal) form_modal.modal("toggle");
                enableSubmitButton(button);
                window.location.href = data.redirect_url;
                // firePixel(window.location);
            },
            error: function (error) {
                enableSubmitButton(button);
                grecaptcha.reset();
                let errorMessage = "An error occurred. Please try again.";

                if (error.responseJSON && error.responseJSON.error) {
                    errorMessage = error.responseJSON.error;
                } else if (error.responseText) {
                    try {
                        const errorResponse = JSON.parse(error.responseText);
                        if (errorResponse.error) {
                            errorMessage = errorResponse.error;
                        }
                    } catch (e) {
                        errorMessage = "An unexpected error occurred.";
                    }
                }
                showErrorToast(errorMessage);
            }
        });
    }

    function validateForm(form) {
        if (form[0].checkValidity() === false) {
            form.addClass("was-validated");
            return false;
        }
        return true;
    }

    const contact_form = "contact_form";
    const submit_query_form = "submit_query_form";
    const free_counselling_form = "free_counselling_form";
    const free_counselling_page_form = "free_counselling_page_form";
    const contact_form_in_services = "contact_form_in_services";

    // Submit Query Form

    $("#" + submit_query_form + "_submit").click(function (e) {
        e.preventDefault();
        var form = $("#" + submit_query_form);
        var modal = $("#" + submit_query_form + "_modal");
        var button = $("#" + submit_query_form + "_submit");
        var thanks_message = $("#" + submit_query_form + "_thanks");

        if (!validateForm(form)) return;
        disableSubmitButton(button);
        showRecaptcha(submit_query_form + "_recaptcha", submitQueryForm);
    });

    function submitQueryForm(recaptcha_token) {
        return new Promise(function (resolve, reject) {
            var form = $("#" + submit_query_form);
            var modal = $("#" + submit_query_form + "_modal");
            var button = $("#" + submit_query_form + "_submit");
            var thanks_message = $("#" + submit_query_form + "_thanks");

            submitWebForm(form, button, recaptcha_token, thanks_message, modal);
            resolve(true);
        });
    }

    $("#" + free_counselling_page_form + "_submit").click(function (e) {
        e.preventDefault();
        var form = $("#" + free_counselling_page_form);
        // var modal = $('#'+free_counselling_form+'_modal');
        var button = $("#" + free_counselling_page_form + "_submit");
        // var thanks_message = $('#'+free_counselling_form+'_thanks');

        if (!validateForm(form)) return;
        disableSubmitButton(button);
        showRecaptcha(
            free_counselling_page_form + "_recaptcha",
            submitCounsellingPageForm
        );
    });

    function submitCounsellingPageForm(recaptcha_token) {
        const response = new Promise(function (resolve, reject) {
            var form = $("#" + free_counselling_page_form);
            var modal = $("#" + free_counselling_page_form + "_modal");
            var button = $("#" + free_counselling_page_form + "_submit");
            var thanks_message = $(
                "#" + free_counselling_page_form + "_thanks"
            );

            submitWebForm(form, button, recaptcha_token, thanks_message, modal);
            resolve(true);
        });

        response
            .then(() => {
                $("#free_counselling_page_form_thanks").show();
            })
            .catch(() => {
                console.log("error");
            });
    }

    $("#" + free_counselling_form + "_submit").click(function (e) {
        e.preventDefault();
        var form = $("#" + free_counselling_form);
        var modal = $("#" + free_counselling_form + "_modal");
        var button = $("#" + free_counselling_form + "_submit");
        var thanks_message = $("#" + free_counselling_form + "_thanks");

        if (!validateForm(form)) return;
        disableSubmitButton(button);
        showRecaptcha(
            free_counselling_form + "_recaptcha",
            submitCounsellingForm
        );
    });

    function submitCounsellingForm(recaptcha_token) {
        return new Promise(function (resolve, reject) {
            var form = $("#" + free_counselling_form);
            var modal = $("#" + free_counselling_form + "_modal");
            var button = $("#" + free_counselling_form + "_submit");
            var thanks_message = $("#" + free_counselling_form + "_thanks");

            submitWebForm(form, button, recaptcha_token, thanks_message, modal);
            resolve(true);
        });
    }

    // Contact Form in Services

    $("#" + contact_form_in_services + "_submit").click(function (e) {
        e.preventDefault();
        var form = $("#" + contact_form_in_services);
        var button = $("#" + contact_form_in_services + "_submit");
        var thanks_message = $("#" + contact_form_in_services + "_thanks");

        if (!validateForm(form)) return;
        disableSubmitButton(button);
        showRecaptcha(
            contact_form_in_services + "_recaptcha",
            submitContactFormInServices
        );
    });

    function submitContactFormInServices(recaptcha_token) {
        return new Promise(function (resolve, reject) {
            var form = $("#" + contact_form_in_services);
            var button = $("#" + contact_form_in_services + "_submit");
            var thanks_message = $("#" + contact_form_in_services + "_thanks");

            submitWebForm(form, button, recaptcha_token, thanks_message);
            resolve(true);
        });
    }

    function submitContactForm(recaptcha_token) {
        return new Promise(function (resolve, reject) {
            var button = $("#contact_form_submit");
            var form = $("#contact_form");
            var thanks_message = $("#contact_form_thanks");
            submitWebForm(form, button, recaptcha_token, thanks_message);
            resolve(true);
        });
    }

    function disableSubmitButton(button) {
        button.addClass("disabled");
        button.text("Submitting");
    }

    function enableSubmitButton(button) {
        button.removeClass("disabled");
        button.text("Submit");
    }

    function showSuccessToast() {
        var form_toast = $("#form-submit-toast");
        form_toast.addClass("show");
        setTimeout(function () {
            form_toast.removeClass("show");
        }, 2000);
    }

    function showErrorToast(message) {
        var form_error_toast = $("#form-submit-toast-error");
        form_error_toast.find(".message").text(message);
        form_error_toast.addClass("show");
        setTimeout(function () {
            form_error_toast.removeClass("show");
        }, 2000);
    }

    function toggleModal(modal) {
        modal.modal("toggle");
    }

    $("#contact_form_submit").click(function (e) {
        e.preventDefault();
        var form = $("#contact_form");
        var button = $("#contact_form_submit");
        if (!validateForm(form)) return;
        disableSubmitButton(button);
        showRecaptcha("contact_form_recaptcha", submitContactForm);
    });

    function showRecaptcha(div_id, callback) {
        try {
            const siteKey = document
                .querySelector('meta[name="recaptcha-site-key"]')
                .getAttribute("content");

            if (typeof widgetId1 !== 'undefined') {
                grecaptcha.reset(widgetId1);
                grecaptcha.execute(widgetId1);
            } else {
                widgetId1 = grecaptcha.render(div_id, {
                    sitekey: siteKey,
                    callback: callback,
                    size: "invisible"
                });
                grecaptcha.execute(widgetId1);
            }
        } catch (err) {
            showErrorToast('Error initializing reCAPTCHA:');
            return false;
        }

        return true;
    }

    $("#videoModal").on("hidden.bs.modal", function (e) {
        $(this).find("iframe").attr("src", "");
    });

    showVideoModal = function (vid, title) {
        console.log("vid", vid);
        $("#videoModal").modal("show");
        $("#videoModal iframe").attr(
            "src",
            "https://www.youtube.com/embed/" + vid + "?controls=1"
        );
        $("#videoModal h5").text(title);
    };

    $(".sop-section-tab-JS .nav-link").click(function () {
        var t = $(this).attr("href");
        $(".active").removeClass("active");
        $("html, body").animate(
            {
                scrollTop: $(t).offset().top - 90,
            },
            {
                duration: 1e3,
            }
        );

        $("body").scrollspy({
            target: ".sop-section-tab-JS",
            offset: $(t).offset().top,
        });
        $(this).parent().addClass("active");

        return false;
    });

    $("body").scrollspy({ target: "#navbar-example2", offset: 0 });

    $("#getItNow").click(function () {
        $("html,body").animate(
            {
                scrollTop: $(".contact-for-sop").offset().top - 100,
            },
            "2000"
        );
    });

    // Iframe Page Section
    $(window).on("load", function () {
        var delayMs = 1500; // delay in milliseconds

        setTimeout(function () {
            $("#frameUserModal").modal("show");
        }, delayMs);
    });
    // Iframe Page Section End

    // Team-flickity section
    $(".flickity-title-card").flickity({
        cellAlign: "left",
        prevNextButtons: true,
        pageDots: false,
        // autoPlay: 4000,
        groupCells: true,
        wrapAround: true,
    });

    // visiblePassworBtn
    $("#visiblePassworBtn").click(function () {
        $(".password-view-style").removeClass("d-none");
        $(".password-view-style").addClass("d-block");
    });

    // For DTYSOP page
    $(".flickity-testimonils3").flickity({
        cellAlign: "left",
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        autoPlay: true,
        wrapAround: true,
        groupCells: true,
    });

    // Mobile Navigation Section
    if (window.matchMedia("(max-width: 768px)").matches) {
        $(".mobile-collapse").addClass("collapse");
    }

    if (window.matchMedia("(min-width: 768px)").matches) {
        // Function to scroll to particular element
        $(function () {
            $(".scrollTopbtn").click(function () {
                if (
                    location.pathname.replace(/^\//, "") ==
                        this.pathname.replace(/^\//, "") &&
                    location.hostname == this.hostname
                ) {
                    var target = $(this.hash);
                    target = target.length
                        ? target
                        : $("[name=" + this.hash.slice(1) + "]");
                    if (target.length) {
                        $("html, body").animate(
                            {
                                scrollTop: target.offset().top - 60,
                            },
                            1000
                        );
                        return false;
                    }
                }
            });
        });
    }

    // accordian section for stysop
    // Add minus icon for collapse element which is open by default
    $(".collapse.show").each(function () {
        $(this)
            .prev(".card-header")
            .find(".fa")
            .addClass("fa-minus")
            .removeClass("fa-plus");
    });

    // Toggle plus minus icon on show hide of collapse element
    $(".collapse")
        .on("show.bs.collapse", function () {
            $(this)
                .prev(".card-header")
                .find(".fa")
                .removeClass("fa-plus")
                .addClass("fa-minus");
        })
        .on("hide.bs.collapse", function () {
            $(this)
                .prev(".card-header")
                .find(".fa")
                .removeClass("fa-minus")
                .addClass("fa-plus");
        });

    if (window.matchMedia("(min-width: 801px)").matches) {
        function isVisible(elment) {
            var vpH = $(window).height(), // Viewport Height
                st = $(window).scrollTop(), // Scroll Top
                y = $(elment).offset().top;

            return y <= vpH + st;
        }

        function setSideNotePos() {
            $(window).scroll(function () {
                var elements = $(".footer-dtysop");
                if (!elements || !elements[0]) return;
                if (isVisible(elements[0])) {
                    $(".dtysop-right-panel-fix").css("position", "absolute");
                    $(".dtysop-right-panel-fix").css(
                        "top",
                        $(".footer-dtysop").offset().top -
                            $(".dtysop-right-panel-fix").outerHeight() -
                            100
                    );
                } else {
                    $(".dtysop-right-panel-fix").css("position", "fixed");
                    $(".dtysop-right-panel-fix").css("top", "140px");
                }
            });
        }
        setSideNotePos();
    }

    // Once you show the overlay
    $("#getStarted").click(function () {
        $("body").prepend('<div class="mask"></div>');
    });

    $("body").click(function () {
        $("div.mask").remove();
    });

    var isSignupShown = false;
    function scrolled(event) {
        var ele = document.getElementById("experience_learning");
        var eleFootercopyright = document.getElementById("mentoringFooter");
        if (ele) {
            let height = window.scrollY + window.innerHeight;
            if (height >= ele.offsetTop) {
                if (height <= eleFootercopyright.offsetTop) {
                    $("#addPopup").addClass("show");
                    isSignupShown = true;
                } else {
                    $("#addPopup").removeClass("show");
                    isSignupShown = false;
                }
            } else {
                $("#addPopup").removeClass("show");
                isSignupShown = false;
            }
        }
    }
    window.onscroll = scrolled;

    // gallery for pdf file
    $("#lightgallery").lightGallery();

    var project1 = $(".tabular-style-section").offset();
    var $window = $(window);

    $window.scroll(function () {
        if ($window.scrollTop() >= project1.top) {
            $("tabular-style-section")
                .removeClass()
                .addClass("tab-padding-style");
        }
    });
});

// mixapanel : byte click event handler

function mixpanelTrackByteClick(userId, moduleTitle, byteUrl) {
    mixpanel.track("Clicked on byte", {
        "User Id": userId,
        "Byte Title": moduleTitle,
        "Byte URL": byteUrl,
    });
}
